<ng-container *ngIf="action$ | async"></ng-container>

<div *ngIf="data$ | async" class="flex flex-row flex-wrap gap-3">
  <csl-item-card
    [disabled]="disabled || topLeftNotAvailableToAdd"
    (selectClicked)="selectProcessing('tl')"
    i18n-title
    data-testid="topLeftAngle"
    title="Левый верхний угол"
    [description]="getDescription(panel?.panelOutline?.topLeft?.mode, 'tl')"
    [iconLink]="getIconLink(panel?.panelOutline?.topLeft?.mode)"
    class="flex-grow">
  </csl-item-card>
  <csl-item-card
    [disabled]="disabled || topRightNotAvailableToAdd"
    (selectClicked)="selectProcessing('tr')"
    [description]="getDescription(panel?.panelOutline?.topRight?.mode, 'tr')"
    [iconLink]="getIconLink(panel?.panelOutline?.topRight?.mode)"
    i18n-title
    data-testid="topRightAngle"
    title="Правый верхний угол"
    class="flex-grow">
  </csl-item-card>
  <csl-item-card
    [disabled]="disabled || bottomLeftNotAvailableToAdd"
    (selectClicked)="selectProcessing('bl')"
    i18n-title
    title="Левый нижний угол"
    data-testid="bottomLeftAngle"
    [description]="getDescription(panel?.panelOutline?.bottomLeft?.mode, 'bl')"
    [iconLink]="getIconLink(panel?.panelOutline?.bottomLeft?.mode)"
    class="flex-grow">
  </csl-item-card>
  <csl-item-card
    [disabled]="disabled || bottomRightNotAvailableToAdd"
    (selectClicked)="selectProcessing('br')"
    data-testid="bottomRightAngle"
    [description]="getDescription(panel?.panelOutline?.bottomRight?.mode, 'br')"
    [iconLink]="getIconLink(panel?.panelOutline?.bottomRight?.mode)"
    i18n-title
    title="Правый нижний угол"
    class="flex-grow">
  </csl-item-card>
</div>
